import React from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as UploadIcon } from "../../assets/icons/addbuilding/upload.svg";

/**
 * FileUploadArea — พื้นที่อัปโหลดรูปภาพแบบ drag-and-drop style
 * ใช้ร่วมกันใน AddBuilding2, AddBuildingEdit, AddBuildingEdit2, AddBuilding3
 *
 * Props:
 *  - accept      : string  — ประเภทไฟล์ที่รับ (default ".jpg,.jpeg")
 *  - fileTypes   : string  — ข้อความแสดงประเภทไฟล์ (default "JPEG")
 *  - selectedFile: File    — ไฟล์ที่เลือกแล้ว (ถ้ามีจะแสดงชื่อไฟล์)
 *  - onChange    : func    — callback(file) เมื่อเลือกไฟล์ใหม่
 *  - className   : string  — class เพิ่มเติม (optional)
 */
export default function FileUploadArea({
  accept = ".jpg,.jpeg",
  fileTypes = "JPEG",
  selectedFile,
  onChange,
  className = "",
}) {
  const { t } = useTranslation();

  const handleChange = (e) => {
    const file = e.target.files?.[0] || null;
    onChange?.(file);
  };

  return (
    <label
      className={`flex flex-col items-center justify-center border-2 border-dashed
        bg-sky-50 border-sky-300 rounded-md cursor-pointer px-7 py-7 m-2
        hover:bg-sky-100 transition ${className}`}
    >
      {/* ไอคอนอัปโหลด */}
      <UploadIcon className="text-slate-500" />

      {/* ข้อความหลัก */}
      <p className="text-sm text-blue-700 font-semibold mt-2">
        {t("admin.addBuilding.addUploadImageLabel")}
      </p>

      {/* ประเภทไฟล์ที่รับ */}
      <p className="text-xs text-gray-500">{fileTypes}</p>

      {/* แสดงชื่อไฟล์ที่เลือกแล้ว */}
      {selectedFile && (
        <p className="text-xs text-slate-700 mt-2 break-all px-2 text-center">
          ✓ {selectedFile.name}
        </p>
      )}

      {/* input จริง (ซ่อนไว้) */}
      <input
        type="file"
        accept={accept}
        className="hidden"
        onChange={handleChange}
      />
    </label>
  );
}
